import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=37e57e96"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports